import { render, staticRenderFns } from "./XeroActionButtons.vue?vue&type=template&id=2fc7a3ff&"
import script from "./XeroActionButtons.vue?vue&type=script&lang=js&"
export * from "./XeroActionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports